module.exports = __webpack_public_path__ + "static/media/background.286f7ba8.png";